export default "__VITE_ASSET__D7eL$0wT__"